import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "../../features/legal/LegalPage";

// Outside the signed-in and signed-out layouts: the texts are read before signing up and from the account alike.
export const Route = createFileRoute("/legal/$document")({
  component: function Legal() {
    return <LegalPage id={Route.useParams().document} />;
  },
});
